import { useQuery } from 'react-query'
import axios from 'axios'
import { serializeQuery } from './utils'

const ENDPOINT = 'api/htl-stock'
const QUERY_KEY = 'stocklist'

export const useGetAllStock = (config = {}) =>
  useQuery(
    [QUERY_KEY, 'detail', 'all'],
    async () => (await axios.get(`${ENDPOINT}/all`)).data,
    config
  )

export const useGetStockList = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'list', query],
    async () => (await axios.get(serializeQuery(ENDPOINT, query))).data,
    config
  )

export const useGetItemId = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'item', query],
    async () => (await axios.get(serializeQuery(`${ENDPOINT}/item`, query))).data,
    config
  )
